module.exports = __webpack_public_path__ + "assets/27946946deb561f8c4a8c7e7105d6a69.svg";